export enum EntityEnum {
  shipment = 'shipment',
  order = 'order',
}
